import { useRef, useState } from 'react';
import Close from '../../assets/icons/close.svg';
import {useOnClickOutside} from '../../hooks/useOnClickOutside'
import './styles.css';
import { NavLink } from 'react-router-dom';
function Sidebar({ isOpen,OnClose }) {
    const sidebarRef = useRef(null);
      
    useOnClickOutside(sidebarRef, () => {
      if(isOpen) {OnClose()}
    });
  return (
    <aside className="sidebar">
      <div className="sidebar-blur" ></div>
      <div className="sidebar-nav" ref={sidebarRef}>
        <img src={Close} onClick={OnClose}></img>
        <nav className="sidebar-nav-content">
          <NavLink
            to="/"
            className="sidebar-nav-item"
            onClick={OnClose}
          >
            Página inicial
          </NavLink>
          <NavLink
            to="/filter"
            className="sidebar-nav-item"
            onClick={OnClose}
          >
            Filtro
          </NavLink>
          <NavLink
            to="/manual"
            className="sidebar-nav-item"
            onClick={OnClose}
          >
            Manual
          </NavLink>
          <NavLink
            to="/sugestoes"
            className="sidebar-nav-item"
            onClick={OnClose}
          >
            Sugestões
          </NavLink>
        </nav>
      </div>
    </aside>
  );
}

export default Sidebar;
